/** Single source of truth: edit this list and `UpdateCheckInterval` follows. */
export const UPDATE_CHECK_INTERVALS = [
    'never',
    '30m',
    '1h',
    '3h',
    '6h',
    '12h',
    '24h',
    '3d',
    '7d',
];
export const DEFAULT_UPDATE_CHECK_INTERVAL = '6h';
const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;
export const UPDATE_CHECK_INTERVAL_MS = {
    '30m': 30 * MIN,
    '1h': HOUR,
    '3h': 3 * HOUR,
    '6h': 6 * HOUR,
    '12h': 12 * HOUR,
    '24h': 24 * HOUR,
    '3d': 3 * DAY,
    '7d': 7 * DAY,
};
export function isUpdateCheckInterval(v) {
    return (typeof v === 'string' &&
        UPDATE_CHECK_INTERVALS.includes(v));
}
